// extracted by mini-css-extract-plugin
module.exports = {"component":"secondary-header-navigation_component__lfx69","navigation":"secondary-header-navigation_navigation__f2Fy5"};